import React, { useState, useMemo } from 'react';
import { Container, Row, Col, Form, Dropdown, Card } from 'react-bootstrap';
import { ChevronDown, FileSpreadsheet, FileText, FileImage, FileType } from 'lucide-react';
import '../../Styles/yellowcalfcss/PaidBills.css';

const mockData = [
  { id: 1, billNumber: 'cgfhgjhjh', supplier: '', billDate: '2022-03-03', dueDate: '2022-03-10', totalAmount: 268 },
  { id: 2, billNumber: '12112', supplier: '', billDate: '2022-03-21', dueDate: '2022-03-22', totalAmount: 262 },
  { id: 3, billNumber: 'new bill', supplier: '', billDate: '2022-01-25', dueDate: '2022-03-27', totalAmount: 260 },
  { id: 4, billNumber: '1712', supplier: '', billDate: '2022-03-01', dueDate: '2022-03-02', totalAmount: 252 },
  { id: 5, billNumber: '123456', supplier: '', billDate: '2022-04-01', dueDate: '2022-04-22', totalAmount: 75 },
  { id: 6, billNumber: '35523', supplier: '', billDate: '2022-05-06', dueDate: '2022-05-12', totalAmount: 32 },
  { id: 7, billNumber: '33612', supplier: '', billDate: '2022-07-12', dueDate: '2022-07-13', totalAmount: 115 },
  { id: 8, billNumber: 'www222', supplier: '', billDate: '2024-04-05', dueDate: '2024-04-14', totalAmount: 120 },
  { id: 9, billNumber: 'www222', supplier: '', billDate: '2024-04-05', dueDate: '2024-04-14', totalAmount: 0 },
  { id: 10, billNumber: 'www222', supplier: '', billDate: '2024-04-05', dueDate: '2024-04-14', totalAmount: 0 },
  { id: 11, billNumber: 'www222', supplier: '', billDate: '2024-04-05', dueDate: '2024-04-14', totalAmount: 0 },
  { id: 12, billNumber: 'www222', supplier: '', billDate: '2024-04-05', dueDate: '2024-04-14', totalAmount: 0 },
  { id: 13, billNumber: 'www222', supplier: '', billDate: '2024-04-30', dueDate: '2024-04-14', totalAmount: 120 }
];

export function PaidBills() {
  const [filters, setFilters] = useState({
    billNumber: '',
    supplier: '',
    billDate: '',
    dueDate: '',
    totalAmount: ''
  });

  const filteredData = useMemo(() => {
    return mockData.filter(b =>
      b.billNumber.toLowerCase().includes(filters.billNumber.toLowerCase()) &&
      b.supplier.toLowerCase().includes(filters.supplier.toLowerCase()) &&
      b.billDate.includes(filters.billDate) &&
      b.dueDate.includes(filters.dueDate) &&
      b.totalAmount.toString().includes(filters.totalAmount)
    );
  }, [filters]);

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  };

  const download = (content, filename, mimeType) => {
    const encoded = encodeURI(`data:${mimeType};charset=utf-8,${content}`);
    const link = document.createElement('a');
    link.setAttribute('href', encoded);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExport = (format) => {
    if (format === 'CSV') {
      const csv = "Bill Number,Supplier,Bill Date,Due Date,Total Amount\n" +
        filteredData.map(b => `${b.billNumber},${b.supplier},${b.billDate},${b.dueDate},${b.totalAmount}`).join('\n');
      download(csv, 'paid_bills.csv', 'text/csv');
    } else if (format === 'JSON') {
      const json = JSON.stringify(filteredData, null, 2);
      download(json, 'paid_bills.json', 'application/json');
    } else {
      window.alert(`${format} export not implemented yet`);
    }
  };

  const handleViewDetails = (id) => {
    window.alert(`Viewing details for bill ID: ${id}`);
  };

  return (
    <div className="financial-billing-main-area">
      <div className="billing-content-organizer">
        <div className="spacing-unit-container">
          <Card className="title-display-module">
            <Card.Body>
              <h3 className="primary-heading-text">Paid Bills</h3>
            </Card.Body>
          </Card>
        </div>

        <div className="spacing-unit-container">
                <Row>
                  <Col md={6} className="input-field-wrapper">
                    <Form.Control
                      type="text"
                      placeholder="Bill Number"
                      value={filters.billNumber}
                      onChange={e => handleFilterChange('billNumber', e.target.value)}
                      className="transparent-search-field"
                    />
                  </Col>
                  <Col md={6} className="input-field-wrapper">
                    <Form.Control
                      type="text"
                      placeholder="Bill Date"
                      value={filters.billDate}
                      onChange={e => handleFilterChange('billDate', e.target.value)}
                      className="transparent-search-field"
                    />
                  </Col>
                </Row>
            
           
        </div>

        <div className="spacing-unit-container">
          <div className="table-data-collection">
            <Card className="header-definition-card table-row-spacing">
              <Card.Body className="row-content-wrapper">
                <Row className="data-alignment-row">
                  <Col md={1} className="column-content-area">Sr No</Col>
                  <Col md={2} className="column-content-area">Bill Number</Col>
                  <Col md={2} className="column-content-area">Supplier</Col>
                  <Col md={2} className="column-content-area">Bill Date</Col>
                  <Col md={2} className="column-content-area">Due Date</Col>
                  <Col md={2} className="column-content-area">Total Amount</Col>
                  <Col md={1} className="column-content-area"></Col>
                </Row>
              </Card.Body>
            </Card>
            {filteredData.map(bill => (
              <Card key={bill.id} className="record-display-card table-row-spacing">
                <Card.Body className="row-content-wrapper">
                  <Row className="data-alignment-row">
                    <Col md={1} className="column-content-area">{bill.id}</Col>
                    <Col md={2} className="column-content-area">{bill.billNumber}</Col>
                    <Col md={2} className="column-content-area">{bill.supplier || '-'}</Col>
                    <Col md={2} className="column-content-area">{bill.billDate}</Col>
                    <Col md={2} className="column-content-area">{bill.dueDate}</Col>
                    <Col md={2} className="column-content-area">
                      {bill.totalAmount === 0 ? '0' : `$ ${bill.totalAmount}`}
                    </Col>
                    <Col md={1} className="column-content-area"></Col>
                  </Row>
                </Card.Body>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
